import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataTabelasReducer } from "../reducers";
import { InitialStateTabelas } from "./models";

const initialState: InitialStateTabelas = {
  items: [],
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {
    idVariavel: "",
  },
  pagination: {
    page: 1,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
};

const tabelasSlice = createSlice({
  name: "variaveisApp/tabelas",
  initialState,
  reducers: {
    openDialogForm: (state, action) => {
      state.dialogForm = {
        open: true,
        content: action.payload,
      };
    },
    closeDialogForm: (state) => {
      state.dialogForm = {
        open: false,
        content: {
          mode: "",
          values: null,
        },
      };
    },
    clearDataTabelas: (state) => {
      state.items = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getTabelaVariaveis.fulfilled, dataTabelasReducer);
  },
});

export const { openDialogForm, closeDialogForm, clearDataTabelas } =
  tabelasSlice.actions;

export default tabelasSlice.reducer;
